export default __webpack_public_path__ + "static/media/News presenter.e6e35eac.svg";